module.exports = __webpack_public_path__ + "static/cvi-3e569d6eafae4b64d54bbe405dc3384b.jpg";